import jsPDF from 'jspdf'
import { captureElementCanvas, captureElementPng } from '@/utils/focusItemCapture'

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.URL.revokeObjectURL(url)
  return true
}

export function fileSlug(name) {
  return (name || 'export').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '') || 'export'
}

function csvCell(value) {
  if (value === null || value === undefined) return ''
  const s = String(value)
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

export function exportRowsCsv(rows, filename) {
  if (!rows || !rows.length) return
  const columns = Object.keys(rows[0])
  const lines = [columns.map(csvCell).join(','), ...rows.map((r) => columns.map((c) => csvCell(r[c])).join(','))]
  downloadBlob(new Blob([lines.join('\n')], { type: 'text/csv' }), filename)
}

export async function exportElementPng(el, filename) {
  const blob = await captureElementPng(el)
  if (blob) downloadBlob(blob, filename)
}

export async function exportElementPdf(el, filename, title) {
  const canvas = await captureElementCanvas(el)
  if (!canvas) return
  const doc = new jsPDF(canvas.width >= canvas.height ? 'l' : 'p', 'pt', 'letter')
  const margin = 32
  const pageW = doc.internal.pageSize.getWidth()
  const pageH = doc.internal.pageSize.getHeight()
  const top = title ? margin + 20 : margin
  if (title) {
    doc.setFontSize(14)
    doc.text(title, margin, margin + 6)
  }
  const width = pageW - margin * 2
  const sliceH = Math.floor(((pageH - top - margin) / width) * canvas.width)
  for (let y = 0, page = 0; y < canvas.height; y += sliceH, page += 1) {
    const slice = document.createElement('canvas')
    slice.width = canvas.width
    slice.height = Math.min(sliceH, canvas.height - y)
    slice.getContext('2d').drawImage(canvas, 0, y, canvas.width, slice.height, 0, 0, canvas.width, slice.height)
    if (page > 0) doc.addPage()
    const offset = page === 0 ? top : margin
    doc.addImage(slice.toDataURL('image/jpeg', 0.9), 'JPEG', margin, offset, width, (slice.height / canvas.width) * width)
  }
  doc.save(filename)
}
